import styles from "./heartbeat-toggle.module.css";

import { inject, observer } from "mobx-react";
import { SensorDataStore } from "../../../store/store";
import { SwitchInput } from "../../../../../components/form-inputs";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

export interface HeartbeatToggleProps {
  sensorDataStore?: SensorDataStore;
}

function HearbeatToggle(props: HeartbeatToggleProps) {
  const sensorDataStore = props.sensorDataStore!;

  const heartbeat = sensorDataStore.selectedSensor.isHeartbeatMonitored;

  return (
    <div className={styles["status-toggle"]}>
      <SwitchInput
        checked={heartbeat}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          sensorDataStore.setSelectedSensorHeartbeat(event.target.checked);
          sensorDataStore.setSelectedSensorHasChanges(true);
          sensorDataStore.validateSelectedSensor();

          if (
            sensorDataStore.selectedSensor
              .heartbeatMonitoringIntervalTimeInMinutes === null ||
            sensorDataStore.selectedSensor
              .heartbeatMonitoringIntervalTimeInMinutes < 5
          ) {
            sensorDataStore!.setSelectedSensorHeartbeatMin(5);
            sensorDataStore.setSelectedSensorHasChanges(true);
            sensorDataStore.validateSelectedSensor(
              "heartbeatMonitoringIntervalTimeInMinutes"
            );
          }
        }}
      />
    </div>
  );
}

export default inject("sensorDataStore")(observer(HearbeatToggle));
